jQuery(document).ready(function () {
	// jQuery('html').addClass("hidden-c");
	// jQuery(".page-width").each(function() {
	// 	jQuery(this).addClass('wowo');
	// });	
	colorPicker();
	stickyHeader();
	productSlider();
	heroSlider();
	tabs();
	addReviews();
	menuBtn();
	loadMoreBtn();
	wowo();
	contactForm();
	gotoNext();
	popup();
	faqs();
	slider();
});

jQuery(window).scroll(function () {
	stickyHeader();
	wowo();
    fixedButton();
});
function faqs() {
	jQuery('.faqs-item').click(function () {
		jQuery(this).toggleClass('open');
		jQuery(this).find('.faqs-content').slideToggle();
	});
}

function colorPicker(){
	if(jQuery('.selector-wrapper select.single-option-selector').length){
		jQuery('.selector-wrapper select.single-option-selector').parents('.product-form__controls-group').prepend('<div class="color--box"><div class="color-text-row"><p><strong>Colour: </strong><span class="color-val"></span></p></div></div>');
	}
	// for(var i = 0;i < jQuery('.selector-wrapper select.single-option-selector option').length;i++){
	// 	var value = jQuery('.selector-wrapper select.single-option-selector option').eq(i).val();
	// 	if(jQuery('.selector-wrapper select.single-option-selector option').eq(i).prop('selected')){
	// 		jQuery('.color-text-row .color-val').text(value);
	// 		jQuery('.color--box .color-list').append('<div class="active" value="' + value + '" title="' + value + '"></div>');
	// 	}else{
	// 		jQuery('.color--box .color-list').append('<div value="' + value + '" title="' + value + '"></div>');
	// 	}
	// }

	jQuery('body').on('click','.color--box .color-list div',function(){
		var val = jQuery(this).attr('value');
		jQuery(this).addClass('active').siblings().removeClass('active');
		jQuery('.color-val').text(val);
		jQuery(this).parents('.color--box').siblings('.selector-wrapper').find('select').val(val);
	})
}

function popup() {
	var cookie_con = 'true';
	var modal = jQuery.cookie('open-modal');
	if (jQuery('.get-off-popup').length > 0) {
		if (modal != cookie_con) {
			jQuery('.get-off-popup').fadeIn();
		} else {
		}
	}
	jQuery('.get-off-popup .close-btn').on("click", function() {
		jQuery.cookie('open-modal', 'true', {
			expires: 30,
			path: '/'
		});
		jQuery('.get-off-popup').fadeOut();
	});
	
	var cookie_con2 = 'true';
	var modal2 = jQuery.cookie('open-modal2');
	if (jQuery('.popup-form').length > 0) {
		if (modal2 != cookie_con2) {
			setTimeout(function() {
				jQuery('.popup-form').addClass('show-popup');
				jQuery('.main-content').addClass('show-popup');
				jQuery('#shopify-section-header').addClass('show-popup');
				
			}, 5000);
		} else {
		}
	}

	jQuery('.popup-form .close-popup-btn').on("click", function() {
		jQuery.cookie('open-modal2', 'true', {
			expires: 365,
			path: '/'
		});
		jQuery('.popup-form').removeClass('show-popup');
		jQuery('.main-content').removeClass('show-popup');
		jQuery('#shopify-section-header').removeClass('show-popup');
	});
	
}

function gotoNext() {
	jQuery('.hero__btn').click(function () {
		var header_H = jQuery('#shopify-section-header').innerHeight();
		var next = jQuery(this).parents('.shopify-section').next().offset().top;
		jQuery('body,html').stop().animate({scrollTop:next-header_H},500);
	});
}

function contactForm() {
	var tel = /^([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})+/; 
	var myreg = /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
	jQuery('.contact-form input[type="submit"]').click(function () {
		jQuery('.contact-form .required-field').each(function () {
			if(jQuery(this).find('textarea').length){
				var val = jQuery(this).find('textarea').val();
			}else{
				var val = jQuery(this).find('input').val();
			}
			if(val==''){
				jQuery(this).addClass('error');
				jQuery(this).find('.required-tips').addClass('show');
			}else{
				if(jQuery(this).find('input').attr('type')=='email'){
			        if(!myreg.test(val)){
			        	jQuery(this).addClass('error');
						jQuery(this).find('.required-tips').addClass('show');
			        }else{
			        	jQuery(this).removeClass('error');
						jQuery(this).find('.required-tips').removeClass('show');
					}
				}else if(jQuery(this).find('input').attr('type')=='tel'){
					if(!tel.test(val)){
			        	jQuery(this).addClass('error');
						jQuery(this).find('.required-tips').addClass('show');
					}else{
			        	jQuery(this).removeClass('error');
						jQuery(this).find('.required-tips').removeClass('show');
					}
				}else{
					jQuery(this).removeClass('error');
					jQuery(this).find('.required-tips').removeClass('show');
				}
			}
		});
		if(jQuery('.required-field.error').length){
			return false;
		}
	});
}

function wowo() {
	var wTop = jQuery(window).scrollTop(),
		wHeight = jQuery(window).height(),
		wBottom = wTop + wHeight;
	jQuery(".wowo:not(.animated)").each(function() {
		var me = jQuery(this),
			meTop = me.offset().top,
			meHeight = me.innerHeight(),
			meBottom = meTop + meHeight,
			limitTop = wTop - meHeight,
			limitBottom = wBottom + meHeight;
		if(meTop > limitTop && meBottom < limitBottom) {
			me.addClass(" animated");
			setTimeout(function() {
				me.removeClass("animated wowo");
			}, 1500);
		}
	});
}

function menuBtn() {
	jQuery('.js-mobile-nav-toggle').click(function () {
		jQuery(this).toggleClass('open');
		jQuery('.mobile-nav-wrapper').toggleClass('open');
	});
}

function loadMoreBtn() {
	jQuery('.product-ajax-load-more-btn').click(function () {
		loadMoreProducts();
	});
}

function loadMoreProducts() {
	var products_on_page = jQuery('.products-on-page');
	var next_url = products_on_page.attr('data-next-url');
	if(next_url){
		jQuery.ajax(
			{
				url:next_url,
				type:'GET',
				dataType:'html'
			}
		).done(function(next_page){
			var new_products = jQuery(next_page).find('.products-on-page');
			var new_url = new_products.data('next-url');
	//		next_url = new_url;
			if(!new_url){
				jQuery('.product-ajax-load-more-row').remove();
			}
			products_on_page.attr('data-next-url',new_url);
			products_on_page.append(new_products.html());
		});
	}
}

function stickyHeader() {
	var scroll = jQuery(window).scrollTop();
	if(scroll>100){
		jQuery('#shopify-section-header').addClass('down');
	}else{
		jQuery('#shopify-section-header').removeClass('down');
	}
}
function fixedButton() {
  if(!jQuery('.template-index').length){
    var scroll = jQuery(window).scrollTop();
    var btntop = jQuery('.product-form__controls-group--submit').offset().top;
    var btnH = jQuery('.product-form__controls-group--submit').innerHeight();
    var headerH = jQuery('#shopify-section-header').innerHeight();
    if( (scroll-headerH) > (btnH+btntop) ){
      jQuery('.product-form__item--submit').addClass('fixed-bottom-button-row');
    }else{
      jQuery('.product-form__item--submit').removeClass('fixed-bottom-button-row');
    }
  }
}

function addReviews() {
//	var iCount = setInterval(GetBack, 100);
//	function GetBack() {
//		var begin = jQuery('.index-section--featured-product .spr-reviews .spr-review').length;
//		if(begin){
//			jQuery('.index-section--featured-product .spr-reviews .spr-review').each(function () {
//				var name = jQuery(this).find('.spr-review-header-byline').find('strong').eq(0).text(),
//					date = jQuery(this).find('.spr-review-header-byline').find('strong').eq(1).text(),
//					star = jQuery(this).find('.spr-starratings').html(),
//					content = jQuery(this).find('.spr-review-content').text();
//				jQuery(this).parents('.index-section--featured-product').find('.reviews-slider').append('<div class="review-item"><div class="item-name">'+name+'</div><div class="item-date">'+date+'</div><div class="item-star">'+star+'</div><div class="item-content">'+content+'</div></div>');
//			});
//
//			clearInterval(iCount);
//		}
//	}
	
			jQuery('.reviews-slider').slick({
				swipe:false,
				touchMove:false,
				fade:false,
				dots: false,
				infinite: true,
				autoplay:true,
				speed:600,
				autoplaySpeed:7000,
				arrows:false,
				slidesToScroll: 1,
				pauseOnHover:false,
		  		slidesToShow: 3,
				focusOnSelect: false,
				responsive: [
					{
						breakpoint: 1160,
						settings: {
							draggable: true,
							swipe:true,
							touchMove:true,
							slidesToShow: 2,
							cssEase: 'cubic-bezier(0.42, 0, 0.58, 1)',
							touchThreshold:100
						}
					},
					{
						breakpoint: 800,
						settings: {
							draggable: true,
							swipe:true,
							touchMove:true,
							slidesToShow: 1,
							cssEase: 'cubic-bezier(0.42, 0, 0.58, 1)',
							touchThreshold:100
						}
					}
				]
			}).on('setPosition', function (event, slick) {
				slick.$slides.css('height', slick.$slideTrack.height() + 'px');
			});

}


function tabs() {
	jQuery('.product-tabs ul li button').click(function () {
		var index = jQuery(this).parent().index();
		jQuery(this).parent().siblings().removeClass('is-active');
		jQuery(this).parent().addClass('is-active');
		jQuery(this).parents('.product-tabs').siblings('.product-content').find('.content-box').eq(index).siblings().css('display','none').removeClass('is-active');
		jQuery(this).parents('.product-tabs').siblings('.product-content').find('.content-box').eq(index).fadeIn().addClass('is-active');
	});
}


function heroSlider() {
	jQuery('.slider-banner .slider-box').slick({
		swipe:false,
		touchMove:false,
		fade:true,
		dots: true,
		infinite: true,
		autoplay:true,
		speed:600,
		autoplaySpeed:7000,
		arrows:true,
		slidesToScroll: 1,
		pauseOnHover:false,
  		slidesToShow: 1,
//		centerMode: true,
		focusOnSelect: true,
		prevArrow: '<button class="prev-btn"><svg width="38px" height="38px" viewBox="0 0 38 38" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M84,408 C91.7319865,408 98,414.268014 98,422 C98,429.731986 91.7319865,436 84,436 C76.2680135,436 70,429.731986 70,422 C70,414.268014 76.2680135,408 84,408 Z M83.2950062,415.895799 C82.7094959,415.310289 81.7601963,415.310289 81.1746861,415.895799 C80.5891759,416.481309 80.5891759,417.430609 81.1746861,418.016119 L81.1746861,418.016119 L85.3045535,422.145666 L81.1746861,426.275548 C80.5891759,426.861058 80.5891759,427.810357 81.1746861,428.395868 C81.7601963,428.981378 82.7094959,428.981378 83.2950062,428.395868 L83.2950062,428.395868 L88.4632863,423.227588 C88.7614154,422.929459 88.9077436,422.537012 88.9022588,422.146221 C88.9079563,421.755225 88.7616322,421.362425 88.4632863,421.064079 L88.4632863,421.064079 Z" id="path-1"></path><filter x="-26.8%" y="-26.8%" width="153.6%" height="153.6%" filterUnits="objectBoundingBox" id="filter-2"><feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.474616894   0 0 0 0 0.474616894   0 0 0 0 0.474616894  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix></filter></defs><g id="BMP0002---Desktop-(Updated)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="01---BMP---Home-Page-(Desktop-HD)-2022" transform="translate(-65.000000, -403.000000)"><g id="Combined-Shape-Copy" transform="translate(84.000000, 422.000000) rotate(-180.000000) translate(-84.000000, -422.000000) "><use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use><use class="color-fill" fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1"></use></g></g></g></svg></button>',
		nextArrow: '<button class="next-btn"><svg width="38px" height="38px" viewBox="0 0 38 38" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M84,408 C91.7319865,408 98,414.268014 98,422 C98,429.731986 91.7319865,436 84,436 C76.2680135,436 70,429.731986 70,422 C70,414.268014 76.2680135,408 84,408 Z M83.2950062,415.895799 C82.7094959,415.310289 81.7601963,415.310289 81.1746861,415.895799 C80.5891759,416.481309 80.5891759,417.430609 81.1746861,418.016119 L81.1746861,418.016119 L85.3045535,422.145666 L81.1746861,426.275548 C80.5891759,426.861058 80.5891759,427.810357 81.1746861,428.395868 C81.7601963,428.981378 82.7094959,428.981378 83.2950062,428.395868 L83.2950062,428.395868 L88.4632863,423.227588 C88.7614154,422.929459 88.9077436,422.537012 88.9022588,422.146221 C88.9079563,421.755225 88.7616322,421.362425 88.4632863,421.064079 L88.4632863,421.064079 Z" id="path-1"></path><filter x="-26.8%" y="-26.8%" width="153.6%" height="153.6%" filterUnits="objectBoundingBox" id="filter-2"><feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.474616894   0 0 0 0 0.474616894   0 0 0 0 0.474616894  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix></filter></defs><g id="BMP0002---Desktop-(Updated)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="01---BMP---Home-Page-(Desktop-HD)-2022" transform="translate(-65.000000, -403.000000)"><g id="Combined-Shape-Copy" transform="translate(84.000000, 422.000000) rotate(-180.000000) translate(-84.000000, -422.000000) "><use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use><use class="color-fill" fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1"></use></g></g></g></svg></button>',
		responsive: [
			{
				breakpoint: 992,
				settings: {
					// fade:false,
					arrows:false,
					draggable: true,
					swipe:true,
					touchMove:true,
					slidesToShow: 1,
					cssEase: 'cubic-bezier(0.42, 0, 0.58, 1)',
					touchThreshold:100
				}
			}
		]
	});
	// jQuery('.slider-banner .btn-link').click(function () {
	// 	var header_H = jQuery('#shopify-section-header').innerHeight();
	// 	var next = jQuery(this).parents('.shopify-section').next().next().offset().top;
	// 	jQuery('body,html').stop().animate({scrollTop:next-header_H},500);
	// });
}

function productSlider() {
  var show = jQuery('.product-form').find('option[selected="selected"]').index();
  jQuery('.variant-slider-wrap').eq(show).addClass('is-show');
  for (var i=1;i<=jQuery('.variant-slider-wrap').length;i++) {
	jQuery('.product-nav-slider-'+i).slick({
		centerPadding: '0',
		swipe:false,
		touchMove:false,
		fade:false,
		dots: false,
		infinite: true,
		autoplay:false,
		speed:600,
		autoplaySpeed:7000,
		arrows:false,
		slidesToScroll: 1,
		pauseOnHover:false,
  		slidesToShow: 5,
//		centerMode: true,
		focusOnSelect: true,
  		asNavFor: '.large-image-slider-'+i,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					draggable: true,
					swipe:true,
					touchMove:true,
					slidesToShow: 6,
					cssEase: 'cubic-bezier(0.42, 0, 0.58, 1)',
					touchThreshold:100
				}
			}
		]
	});
	
	jQuery('.large-image-slider-'+i).slick({
		centerPadding: '0',
		swipe:false,
		touchMove:false,
		fade:false,
		dots: true,
		infinite: true,
		autoplay:false,
		speed:600,
		autoplaySpeed:7000,
		arrows:false,
		slidesToScroll: 1,
		pauseOnHover:false,
  		slidesToShow: 1,
//		centerMode: true,
//		focusOnSelect: true,
  		asNavFor: '.product-nav-slider-'+i,
	});
  }
	
	
}

function slider(){
	if(jQuery('.logo-bar').length){
		jQuery('.logo-bar').slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			infinite: true,
			autoplay:false,
			speed:600,
			autoplaySpeed:5000,
			pauseOnHover:false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 3,
					}
				},
			]
		})
	}
}

function appHeight() {
    const doc = document.documentElement;
    doc.style.setProperty('--vh', (window.innerHeight * .01) + 'px');
}

window.addEventListener('resize', appHeight);
appHeight();